import { UseQueryResult, useQuery } from "@tanstack/react-query";
import {
	BookieData,
	BookingCodesDTO,
	SupportedBookies,
	TipsterDto,
	UserDto,
} from "../../module/global.types";
import api from "../api";

export function useBookieCodeData(
	params: Record<string, string>,
	enabled = false
): UseQueryResult<BookieData[]> {
	return useQuery({
		queryFn: () =>
			api
				.get(`/bookingcode/bookingCodeData`, {
					params,
				})
				.then((resp) => resp.data),
		queryKey: ["bookie-code", params.bookingCode, params.originBookie],
		enabled,
		refetchOnWindowFocus: false,
		staleTime: 1000 * 60 * 60, // Keep cached for an hour
	});
}

export function useGetCurrentUser(): UseQueryResult<UserDto[]> {
	return useQuery({
		queryFn: () => api.get(`/user`).then((resp) => resp.data),
		queryKey: ["auth-user"],
		enabled: false,
	});
}

export function useGetTipsters(): UseQueryResult<TipsterDto[]> {
	return useQuery({
		queryFn: () => api.get(`/user/tipsters`).then((resp) => resp.data),
		queryKey: ["user-tipster"],
	});
}

export function useGetBookingCodes(
	params: BookingCodesDTO,
	enabled?: boolean
): UseQueryResult<BookieData[]> {
	return useQuery({
		queryFn: () =>
			api
				.get(`/bookingcode/filter`, {
					params,
				})
				.then((resp) => resp.data),
		queryKey: ["private-code"],
		enabled: enabled === undefined ? true : Boolean(enabled),
	});
}

export function useUserPublicCodes(
	params: BookingCodesDTO,
	enabled?: boolean
): UseQueryResult<BookieData[]> {
	return useQuery({
		queryFn: () =>
			api
				.get(`/bookingcode/publicFilter`, {
					params,
				})
				.then((resp) => resp.data),
		queryKey: ["bookie-code"],
		enabled: Boolean(enabled),
	});
}

export function useSupportedBookies(
	locale: string
): UseQueryResult<SupportedBookies[]> {
	return useQuery({
		queryFn: () =>
			api
				.get(`/bookingcode/supportedBookies?countryCode=${locale}`)
				.then((resp) => {
					const data = resp.data ?? {};
					let resp_data = [];
					for (let element in data) {
						resp_data.push(data[element]);
					}
					return resp_data;
				}),
		queryKey: ["supported-bookie", locale],
		refetchOnWindowFocus: false,
		staleTime: 1000 * 60 * 60 * 24, // Keep cached for 24 hours
	});
}
